import { render, staticRenderFns } from "./loader.vue?vue&type=template&id=0996ac90&scoped=true"
import script from "./loader.ts?vue&type=script&lang=ts&external"
export * from "./loader.ts?vue&type=script&lang=ts&external"
import style0 from "./loader.scss?vue&type=style&index=0&id=0996ac90&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0996ac90",
  null
  
)

export default component.exports